export default "__VITE_ASSET__DC6Qowiw__"